module.exports = __webpack_public_path__ + "img/icon-docs-grey.3ae576aa.svg";